export default () => {
  if (!window?.Highcharts) {
    throw new Error('Highcharts is not available!');
  }

  return window.Highcharts;
};
